var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCaretDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.7076 12.7071L16.7076 22.7071C16.6147 22.8001 16.5044 22.8738 16.383 22.9241C16.2616 22.9745 16.1315 23.0004 16.0001 23.0004C15.8687 23.0004 15.7385 22.9745 15.6171 22.9241C15.4957 22.8738 15.3854 22.8001 15.2926 22.7071L5.29257 12.7071C5.10493 12.5194 4.99951 12.2649 4.99951 11.9996C4.99951 11.7342 5.10493 11.4797 5.29257 11.2921C5.48021 11.1044 5.7347 10.999 6.00007 10.999C6.26543 10.999 6.51993 11.1044 6.70757 11.2921L16.0001 20.5858L25.2926 11.2921C25.3855 11.1992 25.4958 11.1255 25.6172 11.0752C25.7386 11.0249 25.8687 10.999 26.0001 10.999C26.1315 10.999 26.2616 11.0249 26.383 11.0752C26.5044 11.1255 26.6147 11.1992 26.7076 11.2921C26.8005 11.385 26.8742 11.4953 26.9245 11.6167C26.9747 11.7381 27.0006 11.8682 27.0006 11.9996C27.0006 12.131 26.9747 12.2611 26.9245 12.3825C26.8742 12.5039 26.8005 12.6142 26.7076 12.7071Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretDown);
export default __webpack_public_path__ + "static/media/caret-down.b8843ca760214d71c2de478e6081ecd9.svg";
export { ForwardRef as ReactComponent };